import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, Routes, Route } from "react-router-dom";

import "./metadata.css";
import { auth } from "../../components/firebase/firebase";

import MetadataStart from "./views/MetadataStart";

function Metadata() {
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/login");
  }, [user, loading]);

  return (
    <div className="Metadata">
      <Routes>
        <Route path="/" element={<MetadataStart />} />
      </Routes>
    </div>
  );
}

export default Metadata;
